import OnboardingPage from '@/views/onboarding/OnboardingPage'

export default function Onboarding() {
  return <OnboardingPage />
}
